<template>
  <v-layout row wrap style="padding: 10px;width: 65%;margin: auto;margin-top: 8px;">
    <v-tabs color="primary" v-model="active" dark slider-color="white">
      <v-tab key="CenterAndExam" ripple>Center Id & Exam Id</v-tab>
      <v-tab key="CenterExamDate" ripple>Center Id , Exam Id & Date</v-tab>
      <v-tab key="CenterExamDateTime" ripple>Center Id , Exam Id , Date & Time</v-tab>
      <v-tab-item key="CenterAndExam">
        <v-card flat>
          <v-form ref="form" lazy-validation class="ClsForForm">
            <v-text-field prepend-icon="subject" v-model="center_id" label="Center ID"></v-text-field>
            <v-text-field prepend-icon="assignment" v-model="exam_id" label="Exam ID"></v-text-field>
            <v-layout row wrap v-if="!loading">
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Center','Result')">Generate Result Sheet</v-btn>
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Center','Standard')">Generate Standard Sheet</v-btn>
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Center','Complete')">Generate Complete Sheet</v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-tab-item>
      <v-tab-item key="CenterExamDate">
        <v-card flat>
          <v-form ref="form" lazy-validation class="ClsForForm">
            <v-text-field prepend-icon="subject" v-model="center_id" label="Center ID"></v-text-field>
            <v-text-field prepend-icon="assignment" v-model="exam_id" label="Exam ID"></v-text-field>

            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy
                    transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Exam Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" @input="menu1 = false"></v-date-picker>
            </v-menu>
            <v-layout row wrap v-if="!loading">
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Date','Result')">Generate Result Sheet</v-btn>
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Date','Standard')">Generate Standard Sheet</v-btn>
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Date','Complete')">Generate Complete Sheet</v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-tab-item>
       <v-tab-item key="CenterExamDateTime">
        <v-card flat>
          <v-form ref="form" lazy-validation class="ClsForForm">
            <v-text-field prepend-icon="subject" v-model="center_id" label="Center ID"></v-text-field>
            <v-text-field prepend-icon="assignment" v-model="exam_id" label="Exam ID"></v-text-field>
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" lazy
                    transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Exam Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
            </v-menu>
            <v-menu ref="menu" v-model="menu3" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time" lazy
                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="time" label="Exam Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu3" v-model="time" full-width @click:minute="$refs.menu.save(time)"></v-time-picker>
            </v-menu>
            <v-layout row wrap v-if="!loading">
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Time','Result')">Generate Result Sheet</v-btn>
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Time','Standard')">Generate Standard Sheet</v-btn>
              <v-btn style="width: 29%;font-size: 10px;" color="primary" @click="GenerateSheet('Time','Complete')">Generate Complete Sheet</v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>
<script>
  export default {
    data(){

      return {

          active    : null,
          date      : null,
          modal     : false,
          time      : null,
          menu1     : false,
          menu2     : false,
          menu3     : false,
          center_id : '',
          exam_id   : '',
          loading   : false
      }
    },
    computed:{
        GetURL(){

          return this.$store.getters.GetProductionUrl

        }
      },
      methods:{
        GenerateSheet(Type,SheetType){
             
            this.$eventHub.$emit("LOADING",'true')
            if(Type == 'Center'){

               let Search_Object = {}
               Search_Object['center_id'] =  parseInt(this.center_id)
               Search_Object['exam_id']   =  parseInt(this.exam_id)
               Search_Object['Type']      = 'Center'
               Search_Object['SheetType'] = SheetType
               this.APICallForGeneration(Search_Object)

            }else if(Type == 'Date'){

                let Search_Object = {}
               Search_Object['center_id'] =  parseInt(this.center_id)
               Search_Object['exam_id']   =  parseInt(this.exam_id)
               Search_Object['exam_date'] =  this.date
               Search_Object['Type']      = 'Date'
               Search_Object['SheetType'] = SheetType
               this.APICallForGeneration(Search_Object)

            }else{

              let Search_Object = {}
              Search_Object['center_id'] =  parseInt(this.center_id)
              Search_Object['exam_id']   =  parseInt(this.exam_id)
              Search_Object['exam_date'] =  this.date
              Search_Object['exam_time'] =  this.time
              Search_Object['Type']      = 'Time'
              Search_Object['SheetType'] = SheetType
              this.APICallForGeneration(Search_Object)

            }
        },
        APICallForGeneration(Info){
  
          this.$http.post(`${this.$store.getters.GetProductionUrl}/analysis/generatesheet`,Info)
                    .then(response =>{

                      response && response['data'] && response['data']['response'] ? window.open(response.data.response, '_blank') : window.open('','_blank');
                      this.$eventHub.$emit("LOADING",'false')

                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Generating Sheet","Color":"red","Close": false });
                    })

        }
      },
      mounted(){

          this.$eventHub.$emit("LOADING",'false')
      }
  }
</script>
<style scoped>
.ClsForForm{
   padding: 25px;
    width: 90%;
    margin: auto;
}
</style>

